var map = {
	"./WhatsApp Image 2025-01-27 at 2.08.47 PM.jpeg": 98716,
	"./WhatsApp Image 2025-01-27 at 2.08.48 PM (1).jpeg": 5765,
	"./WhatsApp Image 2025-01-27 at 2.08.48 PM (2).jpeg": 18586,
	"./WhatsApp Image 2025-01-27 at 2.08.48 PM.jpeg": 34415,
	"./WhatsApp Image 2025-01-27 at 2.08.49 PM.jpeg": 40026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97442;